document.addEventListener('DOMContentLoaded', () => {

    const form = document.getElementById('seoForm');
    if (!form) return;

    const fields = form.querySelectorAll('input, select, textarea');
    const submitBtn = form.querySelector('button[type="submit"]');
    const successBox = document.getElementById('formSuccess');
    const errorBox = document.getElementById('formError');

    /* =====================================================
       VALIDATION RULES
    ===================================================== */

    const validators = {
        name: value => value.trim().length >= 2,

        email: value => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),

        website: value => {
            if (!value.trim()) return false;

            let testUrl = value.trim();
            if (!/^https?:\/\//i.test(testUrl)) {
                testUrl = 'https://' + testUrl;
            }

            try {
                const url = new URL(testUrl);
                const hostname = url.hostname;

                if (!hostname.includes('.')) return false;
                if (hostname.endsWith('.')) return false;

                const domainRegex = /^[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
                if (!domainRegex.test(hostname)) return false;

                const parts = hostname.split('.');
                const tld = parts[parts.length - 1];
                if (tld.length < 2) return false;

                return true;

            } catch {
                return false;
            }
        },

        reason: value => value !== '',

        message: value => {
            if (!value.trim()) return true;
            return value.length <= 2000;
        }
    };

    /* =====================================================
       ERROR HANDLING
    ===================================================== */

    function showError(field, message) {
        field.classList.add('is-invalid');
        const feedback = field.parentElement.querySelector('.invalid-feedback');
        if (feedback) feedback.textContent = message;
    }

    function clearError(field) {
        field.classList.remove('is-invalid');
        const feedback = field.parentElement.querySelector('.invalid-feedback');
        if (feedback) feedback.textContent = '';
    }

    function clearAllErrors() {
        fields.forEach(field => clearError(field));
    }

    function validateField(field) {
        const name = field.name;
        const value = field.value;

        if (!validators[name]) return true;

        const isValid = validators[name](value);

        if (!isValid) {
            let message = 'Invalid field.';

            switch (name) {
                case 'name': message = 'Name must be at least 2 characters.'; break;
                case 'email': message = 'Enter a valid email address.'; break;
                case 'website': message = 'Enter a valid website (example: dentist.com).'; break;
                case 'reason': message = 'Please select an option.'; break;
                case 'message': message = 'Message must be under 2000 characters.'; break;
            }

            showError(field, message);
        } else {
            clearError(field);
        }

        return isValid;
    }

    function validateForm() {
        let valid = true;
        fields.forEach(field => {
            if (!validateField(field)) valid = false;
        });
        return valid;
    }

    /* =====================================================
       RECAPTCHA (DYNAMIC LOAD – NO RENDER BLOCKING)
    ===================================================== */

    function loadRecaptcha() {
        return new Promise((resolve, reject) => {

            if (window.grecaptcha) {
                resolve();
                return;
            }

            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?render=${window.recaptchaSiteKey}`;
            script.async = true;
            script.defer = true;

            script.onload = () => resolve();
            script.onerror = () => reject('Failed to load reCAPTCHA');

            document.head.appendChild(script);
        });
    }

    async function executeRecaptcha(action) {
        await loadRecaptcha();

        return new Promise((resolve, reject) => {

            if (!window.grecaptcha) {
                reject('reCAPTCHA not available');
                return;
            }

            grecaptcha.ready(() => {
                grecaptcha.execute(window.recaptchaSiteKey, { action })
                    .then(resolve)
                    .catch(reject);
            });

        });
    }

    /* =====================================================
       FORM SUBMISSION
    ===================================================== */

    async function submitForm() {

        clearAllErrors();
        successBox.classList.add('d-none');
        errorBox.classList.add('d-none');

        submitBtn.disabled = true;
        submitBtn.innerText = 'Submitting...';

        try {

            // 1️⃣ Get reCAPTCHA token
            const token = await executeRecaptcha('seo_form_submit');

            document.getElementById('recaptchaToken').value = token;

            const formData = new FormData(form);

            // 2️⃣ Send AJAX request
            const response = await fetch(form.action, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    'Accept': 'application/json'
                },
                body: formData
            });

            const data = await response.json();

            if (!response.ok) {

                if (data.errors) {
                    Object.keys(data.errors).forEach(key => {
                        const field = form.querySelector(`[name="${key}"]`);
                        if (field) showError(field, data.errors[key][0]);
                    });
                } else {
                    errorBox.textContent = 'Something went wrong.';
                    errorBox.classList.remove('d-none');
                }

            } else {

                successBox.textContent = data.message;
                successBox.classList.remove('d-none');
                form.reset();
            }

        } catch (error) {

            console.error(error);
            errorBox.textContent = 'Security verification failed. Please try again.';
            errorBox.classList.remove('d-none');
        }

        submitBtn.disabled = false;
        submitBtn.innerText = 'Get My Free SEO Review';
    }

    /* =====================================================
       EVENT LISTENERS
    ===================================================== */

    fields.forEach(field => {
        field.addEventListener('blur', () => validateField(field));
    });

    form.addEventListener('submit', e => {
        e.preventDefault();
        if (validateForm()) submitForm();
    });

});